import { Navigate } from "react-router-dom"

export function SettingsIndexPage() {
  return <Navigate to="/settings/company" replace />
}
